<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Product" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-product-form [product]="product" *ngIf="product"></app-product-form>
        </form>
      </div>
    </section>
  </div>
</div>


